import React from 'react'

export default function MainModal() {
  return (
    <div>MainModal</div>
  )
}
